/**
 * "View as client" — lets a curator drop the admin chrome and see the app
 * exactly as a visitor does, without logging out.
 *
 * Kept in sessionStorage so it lasts the tab and resets on the next visit: a
 * curator who toggles it to check a page should not find their tools missing
 * tomorrow.
 */

const KEY = 'adminViewAsClient';
const EVENT = 'admin-view-changed';

export const isViewingAsClient = (): boolean => {
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

export const setViewAsClient = (value: boolean): void => {
  try {
    if (value) sessionStorage.setItem(KEY, '1');
    else sessionStorage.removeItem(KEY);
  } catch {
    /* private mode — the toggle simply does not persist */
  }
  window.dispatchEvent(new Event(EVENT));
};

/** Subscribe to changes so every mounted surface flips at once. */
export const onAdminViewChange = (handler: () => void): (() => void) => {
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
};
